import React from 'react'
import { observer } from 'mobx-react-lite'
import TableCell from '@mui/material/TableCell'
import { CustomTableLocalRow } from '../CustomTableLocalRow'
import { CustomTableCheck } from './CustomTableCheck'
import { stylesRowOpenedNoBorder } from './shared-styles'
import { useTheme } from 'theme/useTheme'
import useCustomTableRenderLog from '../hooks/useCustomTableRenderLog'
import useStore from 'reusable/mobx-store-utils'
import useClasses from 'theme/UseClasses'

interface CustomTableRowSelectionCellProps<RowData extends AnyObject, RowStore> {
   localRow: CustomTableLocalRow<RowData, RowStore>
}

export const CustomTableRowSelectionCell = observer(function CustomTableRowSelectionCell
   <RowData extends AnyObject, RowStore>(
      props: CustomTableRowSelectionCellProps<RowData, RowStore>
   ) {
   useCustomTableRenderLog('CustomTableRowSelectionCell')
   const classes = useClasses(stylesRowOpenedNoBorder)
   const theme = useTheme()

   const localStore = useStore(() => ({
      get cellStyle(): React.CSSProperties {
         return {
            whiteSpace: 'nowrap',
            maxWidth: '1%',
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
         }
      },
   }))

   return (
      <TableCell
         className={props.localRow.collapsibleOpen ? classes.cellOpened : classes.cellClosed}
         style={localStore.cellStyle}
         align="center">
         <CustomTableCheck row={props.localRow} />
      </TableCell>
   )
}
)
